window.onload = function(){
  for (var popup of document.getElementsByClassName("people-popup")) {
      popup.addEventListener('show.bs.modal', function() {
        var modalBody = this.getElementsByClassName('modal-body')[0]
        modalBody.addEventListener('scroll', function(e) {
          if(e.target.scrollTop >= 20){
            modalBody.classList.add('full-bg')
          } else {
            modalBody.classList.remove('full-bg')
          }
        });
      })
  }
}
